import React from 'react'
import { Card, Text, Link, IconButton } from 'theme-ui'
import {  FaBuilding } from 'react-icons/fa'
import Section from '@components/Section'

const WhoWeAre = () => {

  return (
      <Section aside title='Who we are'>
          <Card variant='paper'>
              <Text variant='p'>Primula Medical Travel is a brand of Pegolas Ventures OÜ.</Text>
              <Text variant='p'>Our company was founded in 2021 and has its roots in Antalya, Munich and Tallinn.</Text>
              <Link href='https://www.pegolas.com/the-team' target='_blank'>
                  <IconButton variant='simple' role='presentation'>
                      <FaBuilding />
                  </IconButton>
                  www.pegolas.com/the-team
              </Link>
              <Text variant='p'/>
              <Text variant='p'>With Primula Medical Travel, we want to give all people from Europe access to high-class and affordable medical treatments.</Text>
              <Text variant='p'>With the possibility of having these treatments carried out with us in the holiday paradise of Antalya, you can have each treatment integrated into your annual holiday if required. We make it possible and plan everything for you. As much service as possible, friendly and professional, no hidden costs.</Text>
              <Text variant='p'>Our medical partners are experienced clinics with excellent reputations. We mention all partners by name and have a contractually agreed marketing right for their services to foreign patients.</Text>
          </Card>
      </Section>
  )
}

export default WhoWeAre
